"use client";

import { Card, CardContent, CardHeader } from "@workspace/ui/components/card";
import { Skeleton } from "@workspace/ui/components/skeleton";

export function ArtistDiscoverySkeleton() {
	return (
		<Card className="flex h-full flex-col overflow-hidden rounded-lg">
			<div className="aspect-square w-full">
				<Skeleton className="h-full w-full rounded-t-lg" />
			</div>
			<CardHeader className="p-3">
				<Skeleton className="h-5 w-24" />
			</CardHeader>
			<CardContent className="flex flex-grow flex-col px-3 pb-3">
				<div className="flex min-h-[20px] gap-1">
					<Skeleton className="h-5 w-16" />
					<Skeleton className="h-5 w-12" />
				</div>
			</CardContent>
		</Card>
	);
}
